module.exports = __webpack_public_path__ + "img/icon-pickup-cost-blue.653402dd.svg";